import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import ActionListDivider from '../action-list-divider/index';
import Heading from '../heading';
import Paragraph from '../paragraph';

const ActionTextGroup = ({ title, description = '', children }) => {
  const isMobile = bowser.mobile;

  const groupClasses = classNames('ws-ui-action-text-group', {
    'ws-ui-action-text-group--mobile': isMobile,
  });

  return (
    <div className={groupClasses}>
      <div className="ws-ui-action-text-group__container">
        <Heading type="heading-5" singleLine>
          {title}
        </Heading>
        <Paragraph size="small" appearance="medium-emphasis">
          {description}
        </Paragraph>
      </div>
      {!!children.length && (
        <div className="ws-ui-action-text-group__content">
          <ActionListDivider />
          {children}
        </div>
      )}
    </div>
  );
};

ActionTextGroup.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node.isRequired,
};

export default ActionTextGroup;
